var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"showpage",on:{"click":function($event){return _vm.close()}}},[_c('div',{staticClass:"showpageinfo",on:{"click":function($event){$event.stopPropagation();}}},[(_vm.type==1)?_c('popup-phone'):_vm._e(),_vm._v(" "),(_vm.type==2)?_c('popup-mail'):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d76f14a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Popup.vue
// module id = null
// module chunks = 